export default __webpack_public_path__ + "static/media/gs8-ha-waitlist-prefs.3ae53372.png";